export default class ChildParentUserRelationship {

    static fromData(data) {
        if (!data) {
            return;
        }

        let relationship = new ChildParentUserRelationship();
        relationship.id = data.id;
        relationship.child = data.child;
        relationship.parentUser = data.parentUser;

        return relationship;
    }
}
